(() => {
  const selector = '[data-pqp-mobile-menu]';
  const breakpoint = window.matchMedia('(max-width: 989px)');

  /** @param {HTMLDetailsElement} details */
  const setupMenu = (details) => {
    if (details.dataset.pqpReady === 'true') return;
    const summary = details.querySelector('summary');
    const nav = details.querySelector('nav');
    if (!summary || !nav) return;

    const sync = () => {
      details.open = !breakpoint.matches;
      details.dataset.pqpReady = 'true';
    };

    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && breakpoint.matches && details.open) {
        event.preventDefault();
        details.open = false;
        summary.focus();
      }
    });

    nav.addEventListener('click', (event) => {
      const target = event.target;
      if (breakpoint.matches && target instanceof Element && target.closest('a')) details.open = false;
    });

    breakpoint.addEventListener('change', sync);
    sync();
  };

  const setHeaderMetrics = () => {
    const header = document.querySelector('.pqp-site-header');
    const headerGroup = document.querySelector('#header-group');
    if (!header || !headerGroup) return;

    const headerHeight = header.offsetHeight;
    const headerGroupHeight = Array.from(headerGroup.children).reduce((height, element) => {
      return height + (element instanceof HTMLElement ? element.offsetHeight : 0);
    }, 0);

    document.body.style.setProperty('--header-height', `${headerHeight}px`);
    document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);

    if (Reflect.get(window, '__pqpObservedHeader') !== header) {
      const previousObserver = Reflect.get(window, '__pqpHeaderObserver');
      if (previousObserver instanceof ResizeObserver) previousObserver.disconnect();
      const observer = new ResizeObserver(setHeaderMetrics);
      observer.observe(header);
      observer.observe(headerGroup);
      Reflect.set(window, '__pqpHeaderObserver', observer);
      Reflect.set(window, '__pqpObservedHeader', header);
    }
  };

  const setupFooterGroups = () => {
    document.querySelectorAll('[data-pqp-footer-group]').forEach((element) => {
      if (!(element instanceof HTMLDetailsElement)) return;
      const footerDetails = element;
      footerDetails.open = !breakpoint.matches;
    });
  };

  const initialise = () => {
    document.querySelectorAll(selector).forEach((element) => {
      if (element instanceof HTMLDetailsElement) setupMenu(element);
    });
    setupFooterGroups();
    requestAnimationFrame(setHeaderMetrics);
  };

  if (!Reflect.get(window, '__pqpHeaderControllerReady')) {
    document.addEventListener('shopify:section:load', initialise);
    window.addEventListener('resize', setHeaderMetrics, { passive: true });
    breakpoint.addEventListener('change', setupFooterGroups);
    Reflect.set(window, '__pqpHeaderControllerReady', true);
  }

  initialise();
})();
